import { EventEmitter } from "@angular/core";
import { getBoolean, returnEmpty } from "@core/_utils/tools.utils";

export class HeaderUser {
    active: boolean;
    allowaddmodeldoc: boolean;
    allowbasket: boolean;
    allowconfigdelegate: boolean; 
    allowconfiguser: boolean; 
    allowmodeler: boolean;
    allowscantouchscreen: boolean; 
    allowsearch: boolean; 
    autoconnectionuser: string; 
    autogenerated: boolean; 
    datebegindelegate: Date;
    dateenddelegate: Date;
    dateexpiration: Date;
    dateexpirationbool: boolean;
    dateupdate: string;
    delegateuserlogin: string;
    desc: string;
    email: string;
    firstname: string;
    groupList: [];
    lastname: string;
    login: string;
    password: string;
    passwordcf: string;
    useautoconnection: boolean; 
    usedelegate: boolean; 
    usertype: number; 
    duplicate: boolean;

    notifyParent: EventEmitter<any> = new EventEmitter(); 

    public Clear() {
        this.active = false;
        this.allowaddmodeldoc = false;
        this.allowbasket = false;
        this.allowconfigdelegate = false; 
        this.allowconfiguser = false; 
        this.allowmodeler = false;
        this.allowscantouchscreen = false; 
        this.allowsearch = false; 
        this.autoconnectionuser = ''; 
        this.autogenerated = false; 
        this.datebegindelegate = new Date();
        this.dateenddelegate = new Date();     
        this.dateexpiration = new Date();
        this.dateexpirationbool = false;
        this.dateupdate = '';
        this.delegateuserlogin = '';
        this.desc = '';
        this.email = '';
        this.firstname = '';
        this.groupList = [];
        this.lastname = '';
        this.login = '';
        this.password = '';
        this.passwordcf = '';
        this.useautoconnection = false; 
        this.usedelegate = false; 
        this.usertype = 0; 
        this.duplicate = false;
    }

    public loadData(adata) {
        this.active = getBoolean(adata.us_active);
        this.allowaddmodeldoc = adata.us_allowaddmodeldoc;
        this.allowbasket = adata.us_allowbasket;
        this.allowconfigdelegate = getBoolean(adata.us_allowconfigdelegate);
        this.allowconfiguser = getBoolean(adata.us_allowconfiguser);
        this.allowmodeler = adata.us_allowmodeler;        
        this.allowscantouchscreen = getBoolean(adata.us_allowscantouchscreen);
        this.allowsearch = getBoolean(adata.us_allowsearch); 
        this.autoconnectionuser = adata.us_autoconnectionuser;
        this.autogenerated = getBoolean(adata.us_autogenerated);
        // Utilistaeur Wizard : attention récup data dans tables différentes
        if (this.autogenerated === true) {
            this.datebegindelegate = adata.uscu_datebegindelegate !== '' ? new Date(adata.uscu_datebegindelegate) : new Date();
            this.dateenddelegate = adata.uscu_dateenddelegate !== '' ? new Date(adata.uscu_dateenddelegate) : new Date();
            this.delegateuserlogin = adata.uscu_delegateuserlogin;
        } else {
            this.datebegindelegate = adata.us_datebegindelegate !== '' ? new Date(adata.us_datebegindelegate) : new Date();
            this.dateenddelegate = adata.us_dateenddelegate !== '' ? new Date(adata.us_dateenddelegate) : new Date();
            this.delegateuserlogin = adata.us_delegateuserlogin;
        }
        this.dateexpiration = adata.us_dateexpiration !== '' && adata.us_dateexpiration !== null ? new Date(adata.us_dateexpiration) : new Date();
        this.dateexpirationbool = adata.us_dateexpiration !== '' && adata.us_dateexpiration !== null ? true : false;
        this.dateupdate = adata.us_dateupdate;
        this.desc = adata.us_desc;
        this.email = adata.us_email;
        this.firstname = adata.us_firstname;
        this.groupList = this.getGroupList(adata.us_grouplist);
        this.lastname = adata.us_lastname;
        this.login = adata.us_login;
        this.password = '`H¤I^D^D#E¤N`';
        this.passwordcf = '`H¤I^D^D#E¤N`';
        this.useautoconnection = getBoolean(adata.us_useautoconnection); 
        this.usedelegate = getBoolean(adata.us_usedelegate);
        this.usertype = adata.us_usertype;
        this.notifyParent.emit();
    }

    public getGroupList(aData) {
        let wGrpList = returnEmpty(aData);
        if (wGrpList !== '') {
            return aData.split(';')
        } else {
            return [];
        }        
    }
}
